import * as React from 'react';
import Link from '@mui/material/Link';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import ContentEditable from 'react-contenteditable'

import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Title from 'src/components/Dashboard/AssetManager/Title';
import { useAppSelector, useAppDispatch } from 'src/hooks';
import { FormControlLabel } from '@mui/material';

import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import { Grid, Paper, Button } from '@mui/material';

import { useDispatch } from 'react-redux';
import { useState, useEffect } from "react";

import {
    getAssets,
    deleteAssets,
    deleteSelectedAssets,
    renameAsset
} from 'src/reducers/basicReducer';

import type { AppDispatch } from 'src/store'

import "src/styles.css";
import EditIcon from '@mui/icons-material/Edit';

// Generate Order Data
function createData(
    id: number,
    date: string,
    name: string,
    shipTo: string,
    paymentMethod: string,
    amount: number,
) {
    return { id, date, name, shipTo, paymentMethod, amount };
}

// TODO - maybe move to constants.tsx (avoid duplication)
const palette = ['#e41a1c', '#377eb8', '#4daf4a', '#984ea3', '#ff7f00', '#ffff33', '#a65628', '#f781bf'];

function preventDefault(event: React.MouseEvent) {
    event.preventDefault();
};

// couldn't get these to work in Typescript:
// https://stackoverflow.com/questions/3730510/javascript-sort-array-and-return-an-array-of-indices-that-indicates-the-positio
// so, obtained the function below by asking ChatGPT:
// "Write a Javascript function that takes an array and returns a permutation which rearranges its first argument
// into ascending or descending order, breaking ties by further arguments"
// where the wording is based on the description of this function
// https://www.rdocumentation.org/packages/base/versions/3.6.2/topics/order
function sortWithTies(arr: Array<number>, direction = 'asc') {
    const permutation = Array.from(arr.keys());
    permutation.sort((i, j) => {
        const cmp = arr[i] - arr[j];
        if (cmp !== 0) {
            return direction === 'asc' ? cmp : -cmp;
        }
        for (let k = 1; k < arr.length; k++) {
            const argCmp = arr[i + k] - arr[j + k];
            if (argCmp !== 0) {
                return direction === 'asc' ? argCmp : -argCmp;
            }
        }
        return i - j;
    });
    return permutation;
}

export default function Asset_table() {

    //const initial_id_set = new Set();
    //const [id_set, set_id_set] = useState(initial_id_set);
    const id_set = new Set();

    // https://stackoverflow.com/questions/70143816/argument-of-type-asyncthunkactionany-void-is-not-assignable-to-paramete
    // https://stackoverflow.com/questions/72163276/why-argument-of-type-asyncthunkactionany-void-is-not-assignable-to-par
    let dispatch = useDispatch<AppDispatch>();

    const clear_all_assets = () => {
        dispatch(deleteAssets());
        return null;
    }

    const clear_selected_assets = () => {
        dispatch(deleteSelectedAssets(Array.from(id_set.values())));
        return null;
    }

    // TODO - consider if we should put the selector function call (?) in the reducers file... probably
    // best if we want to use the same selector in multiple points.
    const points = useAppSelector((state: any) => state.basic.pointData.coords);
    const ids = useAppSelector((state: any) => state.basic.pointData.ids);
    const site_name = useAppSelector((state: any) => state.basic.pointData.site_name);
    const ord = sortWithTies(ids); // order table rows by id variable
    console.log("ids: " + ids);
    console.log("ord: " + ord);

    // https://codesandbox.io/s/n3n06xonk0?file=/demo.js
    const handleCheckboxClick = (event: any, id: any) => {
        //event.stopPropagation();
        console.log("checkbox select: " + id);
        console.log("status: " + event.target.checked);
        if (event.target.checked) {
            id_set.add(id);
        } else {
            //set_id_set(id_set.delete(id));
            id_set.delete(id); // not sure why we need the "set_id_set" function at all
        }
        console.log("id set: " + Array.from(id_set.values()));
    };

    const handleChange = (evt: any) => {
        //console.log(evt);
        //this.setState({ html: evt.target.value });
    };

    // https://github.com/lovasoa/react-contenteditable/issues/161
    const handleBlur = (evt: any, id: any) => {
        console.log("blur");
        console.log(evt.target.innerHTML);
        console.log(id);
        dispatch(renameAsset({ 'id': id, 'new_name': evt.target.innerHTML }));
        //this.setState({ html: evt.target.value });
    };

    return (
        <React.Fragment>
            <Grid container>
                <Title>Assets</Title>
                {/* https://stackoverflow.com/questions/60858895/how-to-align-one-item-left-and-another-right-using-material-ui-grid-components */}
                <Grid item xs>
                    <Grid container direction="row-reverse">
                        <Button variant="contained" onClick={clear_selected_assets} color="primary" sx={{ ml: 2 }}>
                            Delete selected
                        </Button>
                        <Button variant="contained" onClick={clear_all_assets} color="primary">
                            Delete all
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
            <Table size="small">
                <TableHead>
                    {/* TODO - consider if we should a "country" column/variable; could be nice for country-scale analytics */}
                    <TableRow>
                        <TableCell align="left">id</TableCell>
                        <TableCell align="left">Color</TableCell>
                        {/* https://github.com/react-icons/react-icons/issues/222
                        https://stackoverflow.com/questions/46262811/react-icon-does-not-align-with-text/67731732 */}
                        <TableCell sx={{ display: "flex", justifyContent: "left" }} align="left">Name&nbsp;&nbsp;&nbsp;<EditIcon /></TableCell>
                        <TableCell align="left">Lat</TableCell>
                        <TableCell align="left">Long</TableCell>
                        <TableCell align="left">Select</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {ord.map((i: any) => (
                        <TableRow key={ids[i]}>
                            <TableCell align="left">{ids[i]}</TableCell>
                            <TableCell align="left">
                                <Box sx={{ width: 40, height: 40, bgcolor: palette[ids[i]], color: 'error.contrastText', p: 2 }}>
                                </Box>
                            </TableCell>
                            <TableCell align="left">
                                {/* https://github.com/lovasoa/react-contenteditable */}
                                <ContentEditable
                                    html={site_name[i]}
                                    onChange={handleChange}
                                    onBlur={event =>
                                        handleBlur(event, ids[i])
                                    }
                                />
                            </TableCell>
                            <TableCell align="left">{points[i].lat.toFixed(3)}</TableCell>
                            <TableCell align="left">{points[i].lng.toFixed(3)}</TableCell>
                            <TableCell align="left">
                                <Checkbox
                                    onClick={event =>
                                        handleCheckboxClick(event, ids[i])
                                    }
                                    className="selectCheckbox"
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            {/* <Link color="primary" href="#" onClick={preventDefault} sx={{ mt: 3 }}>
                See more orders
            </Link> */}
        </React.Fragment>
    );
}
